document.addEventListener('DOMContentLoaded', function () {
	const HARBOUR_INTERNATIONAL_COOKIE = 'harbour_international_acknowledged';
	const GEOIP_RETRY_DELAY = 1000; // 1 second
	const COOKIE_EXPIRY_DAYS = 1;
	const MAX_RETRIES = 3;

	let retryCount = 0;
	let popupElement = null;

	// Cache DOM element
	function getPopupElement() {
		if (!popupElement) {
			popupElement = document.getElementById('geoip-popup-container');
		}
		return popupElement;
	}

	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
		return null;
	}

	function setCookie(name, value, days) {
		let expires = '';
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
	}

	function showPopup() {
		const popup = getPopupElement();
		if (popup) {
			popup.style.display = 'flex';
		}
	}

	function hidePopup() {
		const popup = getPopupElement();
		if (popup) {
			popup.style.display = 'none';
		}
	}

	function handleGeoIP(countryIsoCode) {
		if (getCookie(HARBOUR_INTERNATIONAL_COOKIE)) {
			return;
		}

		if (countryIsoCode && countryIsoCode.toUpperCase() !== 'US') {
			showPopup();
		}
	}

	function initializeGeoIP() {
		if (typeof geoip2 === 'undefined') {
			if (retryCount < MAX_RETRIES) {
				retryCount++;
				setTimeout(initializeGeoIP, GEOIP_RETRY_DELAY);
			}
			return;
		}

		geoip2.country(
			function (countryData) {
				if (countryData && countryData.country && countryData.country.iso_code) {
					console.log('countryData.country.iso_code', countryData.country.iso_code);
					handleGeoIP(countryData.country.iso_code);
				} else if (
					countryData &&
					countryData.registered_country &&
					countryData.registered_country.iso_code
				) {
					console.log(
						'countryData.registered_country.iso_code',
						countryData.registered_country.iso_code
					);
					handleGeoIP(countryData.registered_country.iso_code);
				}
			},
			function (error) {
				console.warn('GeoIP lookup failed:', error);
			}
		);
	}

	initializeGeoIP();

	document.addEventListener('click', function (event) {
		if (event.target && event.target.id === 'geoip-understand-button') {
			setCookie(HARBOUR_INTERNATIONAL_COOKIE, 'true', COOKIE_EXPIRY_DAYS);
			hidePopup();
		}
	});
});
